
import { trackLoginImpression, trackRegTrigger } from '@/plugins/hwtag/events'

export default {
  name: 'AuthDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalVisible: this.visible,
      isHidden: false,
      lastScrollTop: 0,
      scrollTimer: null,

      // 新增 👇
      accumulatedScroll: 0, // 累计滚动距离
      scrollThreshold: 40,  // 触发阈值（可调）
      ticking: false        // rAF锁
    };
  },
  watch: {
    // 监听外部传入的 visible prop
    visible(newVal) {
      this.internalVisible = newVal;
      // 如果外部设置了 visible 为 true，可能需要取消隐藏状态
      if (newVal) {
        this.isHidden = false;
      }
    }
  },
  mounted() {
    this.addScrollListener();
  },
  beforeDestroy() {
    this.removeScrollListener();
  },
  methods: {
    openRegisterModal() {
      this.updateVisibility(false)
      trackLoginImpression('曝光', '中间的活动浮窗')
      trackRegTrigger('点击', '中间的活动浮窗', 'Sign up')
      this.$emit('open-register')
    },
    addScrollListener() {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    removeScrollListener() {
      // 需与 addEventListener 的 options 一致，否则部分环境下无法移除
      window.removeEventListener('scroll', this.handleScroll, { passive: true });
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    handleScroll() {
      if (this.ticking) return;

      this.ticking = true;

      requestAnimationFrame(() => {
        const currentScrollTop = Math.max(
          0,
          window.pageYOffset || document.documentElement.scrollTop || 0
        );

        const delta = currentScrollTop - this.lastScrollTop;

        // 抽屉未展示时仍需释放 ticking，否则后续滚动会永远被 rAF 锁挡住
        if (!this.internalVisible) {
          this.lastScrollTop = currentScrollTop;
          this.ticking = false;
          return;
        }
        // 上下滚动都累计位移，避免只有向下才会收起
        const distance = Math.abs(delta);
        if (distance > 0) {
          this.accumulatedScroll += distance;
          if (this.accumulatedScroll > this.scrollThreshold) {
            this.isHidden = true;
          }
        }

        this.lastScrollTop = currentScrollTop;
        this.ticking = false;
      });

      // ✅ 滚动停止检测
      if (this.scrollTimer) clearTimeout(this.scrollTimer);

      this.scrollTimer = setTimeout(() => {
        if (this.internalVisible) {
          this.isHidden = false;
          this.accumulatedScroll = 0; // 重置
        }
      }, 1500);
    },
    updateVisibility(val) {
      // this.internalVisible = val;
      // 通知父组件更新
      this.$emit('update:visible', val);
    }
  },
};
